import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import { getlocalstorage } from './../../../constants/local_storage'
//import { push } from "connected-react-router";

import * as actions from './actions'
import moment from 'moment'

function* loadVehicleinarea(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )
  const USER_ID = getlocalstorage(localStorage.getItem('profile'), 'id')

  const {
    data: {
      list_vehicle_id,
      vehicle_type_id,
      list_location_id,
      eventdate,
      type_file,
    },
  } = action.payload
  const date_start = moment(eventdate[0]['_d']).format('YYYY-MM-DD HH:mm')
  const date_end = moment(eventdate[1]['_d']).format('YYYY-MM-DD HH:mm')

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_API_REPORT_LOGIN}/service/report/vehicleinarea`,
      {
        date_start,
        date_end,
        list_vehicle_id,
        list_location_id,
        company_id: COMPANY_ID,
        vehicle_type_id,
        user_id: USER_ID,
        type_file,
      },
      //  { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } }
    )

    yield put(actions.loadVehicleinarea.success(res.data))
    window.location = res.data.data
  } catch (err) {
    yield put(actions.loadVehicleinarea.failure())
  }
}

function* loadVehicleinareapreview(action) {
  const {
    data: {
      date_start,
      date_end,
      list_vehicle_id,
      list_location_id,
      company_id,
      vehicle_type_id,
      user_id,
      type_file,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_API_REPORT_LOGIN}/service/report/vehicleinarea`,
      {
        date_start,
        date_end,
        list_vehicle_id,
        list_location_id,
        company_id,
        vehicle_type_id,
        user_id,
        type_file,
      },
    )

    yield put(actions.loadVehicleinareapreview.success(res.data))
    window.location = res.data.data
  } catch (err) {
    yield put(actions.loadVehicleinareapreview.failure())
  }
}

function* loadVehicle(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )
  const vehicle_visibility = getlocalstorage(
    localStorage.getItem('profile'),
    'vehicle_visibility',
  )

  const { vehicletypeID } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getvehiclebygroupid`,
      {
        companyID: COMPANY_ID,
        vehicletypeID: vehicletypeID,
        allow_vehicles: vehicle_visibility,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
    yield put(actions.loadVehicle.success(res.data))
  } catch (err) {
    yield put(actions.loadVehicle.failure())
  }
}

function* loadVehicleType(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getgroupvehicle`,
      {
        company_id: COMPANY_ID,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
      },
    )
    yield put(actions.loadVehicleType.success(res.data))
  } catch (err) {
    yield put(actions.loadVehicleType.failure())
  }
}

function* loadLocation(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )

  const location_visibility = getlocalstorage(
    localStorage.getItem('profile'),
    'location_visibility',
  )

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getlocation`,
      {
        company_id: COMPANY_ID,
        location_visibility,
        name: '',
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
    yield put(actions.loadLocation.success(res.data))
  } catch (err) {
    yield put(actions.loadLocation.failure())
  }
}

export default function* watchReportPoolState() {
  yield all([
    takeEvery(actions.LOAD_VEHICLEINAREA.REQUEST, loadVehicleinarea),
    takeEvery(
      actions.LOAD_VEHICLEINAREA_PREVIEW.REQUEST,
      loadVehicleinareapreview,
    ),
    takeEvery(actions.LOAD_VEHICLE_VEHICLEINAREA.REQUEST, loadVehicle),
    takeEvery(actions.LOAD_VEHICLE_TYPE_VEHICLEINAREA.REQUEST, loadVehicleType),
    takeEvery(actions.LOAD_LOCATION_VEHICLEINAREA.REQUEST, loadLocation),
  ])
}

export {
  loadVehicleinarea,
  loadVehicle,
  loadVehicleType,
  loadLocation,
  loadVehicleinareapreview,
}
